// script for preselect first option of subscription
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const input = document.querySelector('.shopify_subscriptions_app_block_label ul input');
    if (input) input.click();
  });
})();
